import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    flag: 1,
    flag1: 1
  },
  mutations: {
    changeNav (state, step) {
      state.flag = step
    },
    changeNavOther (state, step) {
      state.flag1 = step
    }
  },
  actions: {
  },
  modules: {
  }
})
